import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LayoutComponent } from '@components/layout/layout.component';
import * as bootstrap from 'bootstrap-italia';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [LayoutComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.css',
})
export class AppComponent {
	title = 'via';
	constructor(router: Router) {
		router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				//scroll to top
				window.scrollTo(0, 0);
			}
		});

		if (environment.production) {
			bootstrap.loadFonts(
				'https://wwwservizi.regione.emilia-romagna.it/includes/TemplatesER/-cdn/bootstrap-italia/v2.8.4/dist/fonts',
			);
		} else {
			bootstrap.loadFonts(
				'https://wwwservizitest.regione.emilia-romagna.it/includes/TemplatesER/-cdn/bootstrap-italia/v2.8.4/dist/fonts',
			);
		}
	}
}
